"use strict";
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = void 0;
/** Checks whether x is a useful number, not NaN and not infinite */
const isNumber = (x) => typeof x === "number" && !isNaN(x) && isFinite(x);
exports.isNumber = isNumber;
//# sourceMappingURL=checks.js.map